import PropTypes from 'prop-types';
import React from 'react';
import { ContextVwoProvider } from './VwoContext';
import withCookies from 'HOCs/withCookies/withCookies';
import { compose } from 'redux';

// Provider function for providing the VWO object instance to the components.

const VwoProvider = ({ children, vwoClientInstance, cookies }) => {
    const onapCookie = cookies.get('onap') || cookies.get('onap_dev');
    const onapSessionLong = onapCookie?.slice(0, onapCookie.indexOf('-'));

    const activate = campaignId => {
        if (onapSessionLong && vwoClientInstance.activate) {
            return vwoClientInstance.activate(campaignId, onapSessionLong);
        }
        return null;
    };

    const track = (campaignId, event, options = {}) => {
        if (onapSessionLong && vwoClientInstance.track) {
            return vwoClientInstance.track(campaignId, onapSessionLong, event, options);
        }
        return null;
    };

    const getVariationName = campaignId => {
        if (onapSessionLong && vwoClientInstance.getVariationName) {
            return vwoClientInstance.getVariationName(campaignId, onapSessionLong);
        }
        return null;
    };

    const value = {
        activate,
        track,
        getVariationName
    };

    return (
        <ContextVwoProvider value={ value } >
            {children}
        </ContextVwoProvider>
    );
};

VwoProvider.propTypes = {
    children: PropTypes.any,
    vwoClientInstance: PropTypes.object.isRequired,
    cookies: PropTypes.shape({
        get: PropTypes.func.isRequired,
        set: PropTypes.func.isRequired
    })
};

export default compose(
    withCookies
)(VwoProvider);
